<div id="socsecurityJuncture" class="container">
  <div class="row">
    @if (!this.FlagService.flagServiceObject[5]['contactinfoJunctureFlag']) {
      <div class="col-12">
        <div class="title">
          <fa-icon [icon]="faIdCard"></fa-icon>
          <h3>{{ 'junctures.socSecurity.title' | translate }}</h3>
        </div>
      </div>
    }

    @if (!this.FlagService.flagServiceObject[5]['contactinfoJunctureFlag']) {
      <div class="input-group p-0">
        <form class="row">
          <div class="col-sm-12 col-md-6">
            <label class="form-label m-0" for="socsecNumber">{{ 'junctures.socSecurity.data.socSecNumber' | translate }}</label>
            <input id="socsecNumber" class="form-control mb-2" maxlength="9" type="text" name="socsec-number" placeholder="000000000" [(ngModel)]="_socsecNumberInput" (ngModelChange)="socsecNumberValidation($event)" [ngClass]="{'required': (!_missingSocSecNumber && validationStarted)}" [attr.disabled]="_missingSocSecNumber? true : null">
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-check">
              <input id="missingSocSecNumber" class="form-check-input" type="checkbox" [checked]="_missingSocSecNumber" (change)="missingSocSecNumber($event)">
              <label class="form-check-label" for="missingSocSecNumber">{{ 'junctures.socSecurity.data.noSocSecNumber' | translate }}</label>
            </div>
          </div>
          <div class="col-sm-12 col-md-12">
            @if (validationStarted && !_missingSocSecNumber) {
              <div>
                <div class="feedback invalid-feedback">{{ errorMessage }}</div>
              </div>
            }
            @if (!_missingSocSecNumber && _socsecNumberInput.length > 0) {
              <div>
                @if (!_socsecNumberInputIsValid) {
                  <div class="feedback invalid-feedback">{{ 'junctures.socSecurity.data.socSecNumberInvalid' | translate }}</div>
                }
              </div>
            }
          </div>
          @if (this._missingSocSecNumber) {
            <div class="col-sm-12 col-md-6">
              <label class="form-label m-0" for="taxNumber">{{ 'junctures.socSecurity.data.taxNumber' | translate }}</label>
              <input id="taxNumber" class="form-control mb-2" maxlength="10" type="text" name="tax-number" placeholder="{{ 'junctures.socSecurity.data.taxNumber' | translate }}" [(ngModel)]="_taxNumberInput" (ngModelChange)="taxNumberValidation($event)" [ngClass]="{'required': (!_missingTaxNumber && !_taxNumberInputIsValid && validationStarted)}" [attr.disabled]="_missingTaxNumber? true : null">
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="form-check">
                <input id="missingTaxNumber" class="form-check-input" type="checkbox" [(ngModel)]="_missingTaxNumber" (change)="missingTaxNumber()">
                <label class="form-check-label" for="missingTaxNumber">{{ 'junctures.socSecurity.data.noTaxNumber' | translate }}</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-12">
              @if (validationStarted && !_passportNumberInputIsValid && !_missingTaxNumber) {
                <div>
                  <div class="feedback invalid-feedback">{{ errorMessage }}</div>
                </div>
              }
              <div>
                @if (!_taxNumberInputIsValid && _taxNumberInput.length > 0) {
                  <div class="feedback invalid-feedback">{{ 'junctures.socSecurity.data.taxNumberInvalid' | translate }}</div>
                }
              </div>
            </div>
          }
          @if (this._missingTaxNumber) {
            <div class="col-12">
              <label class="form-label m-0" for="passportNumber">{{ 'junctures.socSecurity.data.passportNumber' | translate }}</label>
              <input id="passportNumber" class="form-control" type="text" name="passport-number" placeholder="{{ 'junctures.socSecurity.data.passportNumber' | translate }}" [(ngModel)]="_passportNumberInput" (ngModelChange)="passportNumberValidation($event)" [ngClass]="{'required': (validationStarted && !_passportNumberInputIsValid)}">
            </div>
            <div class="col-12">
              @if (validationStarted && !_taxNumberInputIsValid) {
                <div>
                  <div class="feedback invalid-feedback">{{ errorMessage }}</div>
                </div>
              }
              <div>
                @if (!_passportNumberInputIsValid && _passportNumberInput.length > 0) {
                  <div class="feedback invalid-feedback">{{ 'junctures.socSecurity.data.passportNumberInvalid' | translate }}</div>
                }
              </div>
            </div>
          }
          <div class="d-flex summary mt-4">
            <div class="w-100">
              <fa-icon class="text-center me-2" [icon]="faIdCard"></fa-icon>
              @if (!this._socsecNumberInput && !this._taxNumberInput && !this._passportNumberInput) {
                <div class="text">
                  <span class="name"></span><br>
                  <span class="date"></span>
                </div>
              }
              @if (this._socsecNumberInput.length > 0) {
                <div class="text">
                  <span class="name">{{ _socsecNumberInput }}</span><br>
                  <span class="date">{{ 'junctures.socSecurity.data.socSecNumber' | translate }}</span>
                </div>
              }
              @if (this._taxNumberInput.length > 0) {
                <div class="text">
                  <span class="name">{{ _taxNumberInput }}</span><br>
                  <span class="date">{{ 'junctures.socSecurity.data.taxNumber' | translate }}</span>
                </div>
              }
              @if (this._passportNumberInput.length > 0) {
                <div class="text">
                  <span class="name">{{ _passportNumberInput }}</span><br>
                  <span class="date">{{ 'junctures.socSecurity.data.passportNumber' | translate }}</span>
                </div>
              }
            </div>
            <div class="flex-shrink-1">
              <button (click)="checkUserdata()" type="button" class="btn btn-light float-end">{{ 'common.ok' | translate }}</button>
            </div>
          </div>
        </form>
      </div>
    }
  </div>

  @if (this.FlagService.flagServiceObject[5]['contactinfoJunctureFlag']) {
    <div class="row feedback-module" (click)="socsecurityJunctureClick()">
      <div class="d-flex p-0">
        <a class="w-100">
          <fa-icon class="text-center ms-3 me-3" [icon]="faIdCard"></fa-icon>
          <div class="text">
            @if (this.insurantData.insuredPerson.socialSecurityNumber) {
              <span class="top">{{ this.insurantData.insuredPerson.socialSecurityNumber }}</span>
            }
            @if (this.insurantData.insuredPerson.taxNumber) {
              <span class="top">{{ this.insurantData.insuredPerson.taxNumber }}</span>
            }
            @if (this.insurantData.insuredPerson.passport) {
              <span class="top">{{ this.insurantData.insuredPerson.passport }}</span>
            }
            <br>
              @if (this.insurantData.insuredPerson.socialSecurityNumber) {
                <span class="bottom">{{ 'junctures.socSecurity.data.socSecNumber' | translate }}</span>
              }
              @if (this.insurantData.insuredPerson.taxNumber) {
                <span class="bottom">{{ 'junctures.socSecurity.data.taxNumber' | translate }}</span>
              }
              @if (this.insurantData.insuredPerson.passport) {
                <span class="bottom">{{ 'junctures.socSecurity.data.passportNumber' | translate }}</span>
              }
            </div>
          </a>
          <div class="flex-shrink-1">
            <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
          </div>
        </div>
      </div>
    }
  </div>
